(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name drug.directive:drughistory
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="drug">
       <file name="index.html">
        <drughistory></drughistory>
       </file>
     </example>
   *
   */
  angular
    .module('drug')
    .directive('drughistory', drughistory);

  function drughistory() {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'drug/drughistory-directive.tpl.html',
      replace: false,
      controllerAs: 'drughistory',
      controller: function () {
        var vm = this;
        vm.name = 'drughistory';
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
